import {
  defaultRelationFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  ApartmentConfig,
  ApartmentContractConfig,
} from '@pigello/pigello-matrix';
import baseFilters, {
  baseGlobalRealEstatesFilter,
  baseTagFilter,
} from '../../filters';
import baseContractFilters from '../components/base-contract-filters';
import { Icons } from '@/components/icons';

const apartmentContractFilters: Filter[] = [
  {
    ...defaultRelationFilter,
    title: ApartmentContractConfig.fields.space.verboseName,
    relationModelName: ApartmentConfig.modelName,
    externalFieldName: ApartmentContractConfig.fields.space.externalFieldName,
    icon: Icons.apartment,
  },
  ...baseGlobalRealEstatesFilter,
  ...baseContractFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default apartmentContractFilters;
